import useI18n from "./useI18n";

export default useI18n;
